import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../../model/user';
import { AlertService } from '@app/services/Alert/alert.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment.prod';

@Injectable({ providedIn: 'root' })
export class UserService {
    //private userSubject: BehaviorSubject<User | null>; TODO -local storage user 
    //public user: Observable<User | null>; TODO -local storage user 

    API_BASE_PATH = environment.API_URL;

    constructor(
        private router: Router,
        private http: HttpClient,
        private route: ActivatedRoute,
        private alertService: AlertService,
        private toastr: ToastrService
    ) {
        //this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')!)); TODO -local storage user 
        //this.user = this.userSubject.asObservable(); TODO -local storage user 
    }

    //public get userValue() {
    //    return this.userSubject.value; TODO -local storage user 
    //}

    setUserUUID(id: string): void {
        localStorage.setItem('UUID', id);
    }

    setToken(token: string): void {
        sessionStorage.setItem('token', token);
    }

    getToken(): string | null {
        return sessionStorage.getItem('token');
    }

    getUserEmail(): string | null {
        return localStorage.getItem('userEmail');
    }

    isLoggedIn(): boolean {
        return this.getToken() !== null;
    }

    login(user_name: string, password: string) {
        return this.http.post<User>(`${this.API_BASE_PATH}login`, { user_name, password })
            .pipe(map(user => {
                //localStorage.setItem('user', JSON.stringify(user)); TODO -local storage user 
                //this.userSubject.next(user); TODO -local storage user 
                this.setToken(user.token as string);
                this.setUserUUID(user.id as any);
                this.isLoggedIn();
                return user;
            }));
    }

    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('UUID');
        localStorage.removeItem('userEmail');
        sessionStorage.removeItem('token');

        this.alertService.success('You have been successfully logged out.', true);
        this.toastr.success('You have been successfully logged out.', '');
        //this.userSubject.next(null); TODO -local storage user 
    }

    register(user: User) {
        return this.http.post(`${this.API_BASE_PATH}register`, user);
    }

    forgotPassword(email: string) {
        return this.http.post(`${this.API_BASE_PATH}forgot-password`, { email });
    }
    
    verifyEmail(id: any, email: string) {
        return this.http.get(`${this.API_BASE_PATH}verify/${id}/${email}`);
    }

    // resetPassword(formData: FormData) {
    //     return this.http.post(`${this.API_BASE_PATH}reset-password`, formData);
    // }
    resetPassword(data: { token: string, password: string, email: string }) {
        return this.http.post(`${this.API_BASE_PATH}reset-password`, data, {headers: { 'Content-Type': 'application/json' }});
    }

    getById(id: any) {
        return this.http.get<User>(`${this.API_BASE_PATH}user/${id}`);
    }

    getPlanById(UUID: any) {
        return this.http.get<User>(`${this.API_BASE_PATH}userPlan/${UUID}`);
    }

    getOrderFeedCount(UUID: any){
        return this.http.get<any>(`${this.API_BASE_PATH}orderFeedCount/${UUID}`);
    }
}
